<template>
  <q-layout>
    <q-page-container>
  <q-page class="bg-primary window-height window-width row justify-center items-center">
    <div class="column">

      <div class="row">

        <q-card  class="q-pa-lg">
          <template v-if="!isSending">
            <q-card-section>

              <q-item class="q-px-none" v-if="user && user.authenticated">
                <q-item-section side>
                  <q-avatar v-if="user.first_name" color="primary" text-color="white">{{user.first_name.substring(0, 1).toUpperCase()}}</q-avatar>
                  <q-avatar v-if="!user.first_name" color="primary" text-color="white">{{user.email.substring(0, 1).toUpperCase()}}</q-avatar>
                </q-item-section>
                <q-item-section v-if="user.first_name">
                  <q-item-label>{{user.first_name}} {{user.last_name}}</q-item-label>
                  <q-item-label caption>{{user.email}}</q-item-label>
                </q-item-section>
                <q-item-section v-if="!user.first_name">
                  <q-item-label>{{user.email}}</q-item-label>
                </q-item-section>
                <q-item-section side>
                  <q-btn @click="this.$router.push('/logout')" class="gt-xs" size="12px" flat dense round icon="s_logout" />
                </q-item-section>
              </q-item>

                <h5 class="text-h6 q-my-md">Dashboard</h5>

              <q-list v-if="forms && forms.length > 0"
                      bordered separator padding class="rounded-borders q-mb-md">
                <template v-for="(place, place_index) in forms"
                          :key="place_index">
                  <q-item clickable @click="selectForm(place_index)" v-ripple   active-class="bg-teal-1 text-grey-8" :active="place_index === index">
                    <q-item-section avatar>
                      <q-icon name="s_text_snippet" color="secondary" />
                    </q-item-section>

                    <q-item-section>
                      <q-item-label>{{forms[place_index].first_name}}</q-item-label>
                      <q-item-label caption lines="1">{{forms[place_index].name}}</q-item-label>
                    </q-item-section>
                    <q-item-section side>
                      <q-item-label>{{forms[place_index].date}}</q-item-label>
                    </q-item-section>

  <!--                  <q-item-section side @click.stop="confirmDeleteAlert(place_index)">-->
  <!--                    <q-icon name="s_delete" color="amber"  />-->
  <!--                  </q-item-section>-->
                  </q-item>
                </template>
              </q-list>
              <p class="q-mb-none"><a class="text-primary text-decoration-none" href="/user/account" target="_blank">show all completed loans</a></p>
            </q-card-section>
            <q-card-actions class="q-px-md">

              <q-btn :loading="isSending" unelevated type="button" @click="this.$router.push('/')" color="primary" size="lg" class="full-width" label="Create new" />
            </q-card-actions>
            <q-card-section class="text-center q-pa-none">
              <p class="text-grey-6">Want to check your other account?  <router-link to="/logout" class="text-primary text-decoration-none">
                <span class="text-weight-bolder ">Logout</span>
              </router-link>
              </p>

            </q-card-section>
          </template>
          <q-card-section v-if="isSending" class="q-py-lg flex flex-center">
            <q-spinner
                color="primary"
                size="3em"
            />
          </q-card-section>
        </q-card>

      </div>
    </div>
  </q-page>
      </q-page-container>
        </q-layout>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import {fetchEnv} from "@/helpers/form";
import {Notify} from "quasar";

export default {
  name: 'ItemsComponent',
  data () {
    return {
      forms: [
        {
          'name' : 'Loan application',
          'date' : '2023-07-11',
          'route' : 'loan'
        },
        {
          'name' : 'Loan application',
          'date' : '2023-06-23',
          'route' : 'loan'
        }
      ],
      isSending: false,
      index: false
    }
  },
  computed: {
    ...mapFields('settings/list', {
      form: 'form',
      user: 'user'
    })
  },
  created () {

  },
  methods: {
    selectForm(place_index) {
      this.index = place_index;
      this.$router.push('/forms/' + this.forms[place_index].id);
    },
  },
  mounted() {

    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get('form');
    this.isSending = true;
    fetchEnv('/front/api/v1/form/list', {
      type
    })
        .then(
            (response) => {
              this.isSending = false;
              if(response.authenticated === undefined || !response.authenticated) {
                let errorBlock = '';
                for(let key in response.error) {
                  errorBlock += '<p style="color: red">'+response.error[key]+'</p>';
                }
                Notify.create(  //'Something went wrong');
                    {
                      message: '<p><em>Something went wrong: you are not authenticated</em></p>' + errorBlock,
                      html: true,
                      timeout:5000
                    });
                this.$router.push('/signup');
                //console.log(response);
              } else {
                //Notify.create('Forms loaded');
                if(response.forms !== undefined && response.forms) {
                    this.forms = response.forms;
                    if(this.forms.length === 0) {
                      this.$router.push('/');
                    }
                }
                //this.$router.push('/forms');
              }
            })
        .catch(error => console.log(error));
  }
}
</script>

<style scoped>
.q-card {
  /*width: 600px;*/
  /*max-width: 90%;*/
}
.text-decoration-none {
  text-decoration: none;
}
</style>